(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dc-banner"] && !Shopify.designMode) return;
  try {
    
window.DC = window.DC || {};
DC.controllers = DC.controllers || {};
DC.controllers['dc-section'] = DC.controllers['dc-section'] || function(root){};
(function(){
  const init = () => document.querySelectorAll('[data-controller="dc-section"]').forEach(el=>{
    if(!el.__dcInit){ el.__dcInit = true; DC.controllers['dc-section'](el); }
  });
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dc-product-tabs"] && !Shopify.designMode) return;
  try {
    
window.DC = window.DC || {};
DC.controllers = DC.controllers || {};

DC.controllers['dc-product-tabs'] = (root) => {
  const btns = [...root.querySelectorAll('[data-tab-btn]')];
  const panels = [...root.querySelectorAll('[data-tab-panel]')];

  const activate = (idx) => {
    btns.forEach((b,i)=>{
      b.classList.toggle('is-active', i===idx);
      b.setAttribute('aria-selected', i===idx ? 'true' : 'false');
      panels[i]?.classList.toggle('is-active', i===idx);
    });
  };

  btns.forEach((b,i)=> b.addEventListener('click', ()=> activate(i)));

  // Keyboard a11y
  root.addEventListener('keydown', (e)=>{
    if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) return;
    const current = btns.findIndex(b => b.classList.contains('is-active'));
    let next = current;
    if(e.key==='ArrowRight') next = (current+1) % btns.length;
    if(e.key==='ArrowLeft')  next = (current-1+btns.length) % btns.length;
    if(e.key==='Home') next = 0;
    if(e.key==='End')  next = btns.length-1;
    btns[next].focus(); activate(next);
  });

  // Init
  activate(0);
};

// Auto-init
(function(){
  const init = () => document.querySelectorAll('[data-controller="dc-product-tabs"]').forEach(el=>{
    if(!el.__dcInit){ el.__dcInit = true; DC.controllers['dc-product-tabs'](el); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
